import StripeLinkStep from '@molecules/StripeLinkStep';
import { StripeRequiredInfo } from '@molecules/StripeRequiredInfo';
import useEventContext from '@hooks/useEventContext';
import { CircularProgress } from '@mui/material';
import { EventForm } from '@components/eventCreation/CreateEventUtils';
import { useFormContext } from 'react-hook-form';

export default function EventPaymentConfig() {
    const { event, stripePaymentUser, stripeState } = useEventContext();
    const { watch } = useFormContext<EventForm>();
    const [eventId] = watch(['id']);

    if (stripeState?.loading) {
        return (
            <div style={{ textAlign: 'center', padding: '5rem' }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <div>
            <StripeRequiredInfo connectedAccountId={stripePaymentUser?.stripeId} />
            <StripeLinkStep
                connectedAccountId={(eventId === event?.id && stripePaymentUser?.stripeId) || ''}
            />
        </div>
    );
}
